export default "__VITE_ASSET__Di2FT68d__"